/* eslint-disable @typescript-eslint/no-use-before-define */
import { Application, BasePlugin } from '@goodboydigital/astro';

import { App } from '../App';
import * as DeviceQueries from '../utils/DeviceQueries';

export class NotchPlugin implements BasePlugin
{
    public app: App;
    public left = 0;
    public right = 0;
    public top = 0;
    public bottom = 0;
    private notchSize = 70;

    constructor(app: Application)
    {
        this.app = app as App;

        if (this.hasNotch())
        {
            window.addEventListener('orientationchange', this.updateMargins.bind(this));
            this.updateMargins();
        }
    }

    public getNotchSize(): number
    {
        return this.hasNotch() ? this.notchSize : 0;
    }

    public hasNotch(): boolean
    {
        return (
            DeviceQueries.isIPhoneX()
            || DeviceQueries.isIPhone11()
            || DeviceQueries.isIPhone11Pro()
            || DeviceQueries.isIPhone11ProMax()
            || DeviceQueries.isIPhone12()
            || DeviceQueries.isIPhone12ProMax()
            || DeviceQueries.isIPhone12Mini()
        );
    }

    public updateMargins(): void
    {
        this.left = 0;
        this.right = 0;
        this.top = 0;
        this.bottom = 0;
        if (!this.hasNotch()) return;

        if ('orientation' in window)
        {
            // Mobile
            switch (window.orientation)
            {
                case 90:
                    this.left = this.notchSize;
                    break;
                case -90:
                    this.right = this.notchSize;
                    break;
            }
        }
        else if ('orientation' in window.screen)
        {
            // Webkit
            switch (screen.orientation.type)
            {
                case 'landscape-primary':
                    this.left = this.notchSize;
                    break;
                case 'landscape-secondary':
                    this.right = this.notchSize;
                    break;
                case 'portrait-primary':
                    this.top = this.notchSize;
                    break;
                case 'portrait-secondary':
                    this.bottom = this.notchSize;
                    break;
            }
        }
        else if ('mozOrientation' in window.screen)
        {
            // Firefox
            switch ((screen as any).mozOrientation)
            {
                case 'landscape-primary':
                    this.left = this.notchSize;
                    break;
                case 'landscape-secondary':
                    this.right = this.notchSize;
                    break;
                case 'portrait-primary':
                    this.top = this.notchSize;
                    break;
                case 'portrait-secondary':
                    this.bottom = this.notchSize;
                    break;
            }
        }
    }
}
